import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css'; // Shared CSS

const CraftEn = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // ▼▼▼ ADDED ▼▼▼
    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>Living with Traditional Crafts | Five Features | Kanazawa Stay Akebono</title>
                <meta name="description" content="Experience the beauty of Ishikawa and Noto's traditional crafts at Akebono. Our guesthouse is adorned with Wajima lacquerware, Kutani porcelain, and Suzu ware." />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="Stay Surrounded by Traditional Crafts | Kanazawa Stay Akebono" />
                <meta property="og:description" content="Experience the beauty of Ishikawa and Noto's traditional crafts. Our guesthouse is adorned with Wajima lacquerware, Kutani porcelain, and Suzu ware." />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/machiya2.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HERO Section */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/machiya2.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>Stay Surrounded by Traditional Crafts</h1>
                    </div>
                </section>

                {/* Section 1: About Traditional Crafts */}
                <section className="akebono-garden-culture">
                    <h2>Traditional Crafts of Ishikawa & Noto</h2>
                    <p>Ishikawa Prefecture is known for its diverse traditional crafts cultivated over centuries. Wajima lacquerware, Kutani porcelain, and Suzu ware reflect the refined aesthetic of the Kaga Domain and the craftsmanship handed down through generations.</p>
                    <p>In the Noto Peninsula, you’ll also find warm, practical crafts like handmade candles, washi paper, and sake vessels — all deeply rooted in the local lifestyle. These are more than decorations: they are tools that soothe the soul and enrich daily life.</p>
                    <p>At Akebono, guests can directly experience these crafts as part of a unique and immersive stay.</p>

                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/craft-ishikawa1.jpg" alt="Wajima Lacquerware" onClick={() => openLightbox('/images/craft-ishikawa1.jpg')} />
                        <img src="/images/craft-ishikawa2.jpg" alt="Kutani Porcelain" onClick={() => openLightbox('/images/craft-ishikawa2.jpg')} />
                        <img src="/images/craft-ishikawa3.jpg" alt="Suzu Ware" onClick={() => openLightbox('/images/craft-ishikawa3.jpg')} />
                        <img src="/images/craft-ishikawa4.jpg" alt="Takazawa Candles" onClick={() => openLightbox('/images/craft-ishikawa4.jpg')} />
                    </div>
                </section>

                {/* Section 2: Crafts Featured Inside the House */}
                <section className="akebono-garden-feature">
                    <h2>Crafts Inside the House</h2>
                    <p>Akebono features exceptional traditional crafts from Ishikawa and Noto throughout its interiors, offering an experience akin to touring an art museum during your stay.</p>

                    <div className="garden-card">
                        <img src="/images/crafts1.jpg" alt="Wajima Lacquerware" onClick={() => openLightbox('/images/crafts1.jpg')} />
                        <div>
                            <h3>Wajima Lacquerware</h3>
                            <p>Made in Wajima City, this lacquerware is known for its durability and elegance. Dozens of layers of lacquer are applied to strengthen the wood base, then decorated with refined techniques such as chinkin (gold inlay) and maki-e (sprinkled gold design).</p>
                            <p>Our displayed pieces are minimalist yet rich in texture — seamlessly blending with modern interiors. View them in the Japanese-style room on the first floor.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/crafts2.jpg" alt="Kutani Porcelain" onClick={() => openLightbox('/images/crafts2.jpg')} />
                        <div>
                            <h3>Kutani Porcelain</h3>
                            <p>Celebrated for its vivid colors and dynamic designs, Kutani porcelain uses five hues — red, blue, yellow, purple, and green — to create intricate paintings over porcelain.</p>
                            <p>We display Kutani tea cups and plates throughout the house. Enjoy them during tea time with our signature roasted tea blend.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/crafts3.jpg" alt="Suzu Ware" onClick={() => openLightbox('/images/crafts3.jpg')} />
                        <div>
                            <h3>Suzu Ware</h3>
                            <p>Suzu ware is unglazed pottery known for its earthy texture and powerful simplicity. Although it once disappeared, it has been revived in modern times and is now loved for its rustic, timeless charm.</p>
                            <p>Visit the upstairs bedrooms to view dishes and sake cups made from Suzu clay — and appreciate their organic, tactile qualities.</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/crafts4.jpg" alt="Takazawa Candles & Incense" onClick={() => openLightbox('/images/crafts4.jpg')} />
                        <div>
                            <h3>Takazawa Candles</h3>
                            <p>Established in Nanao, Noto, Takazawa Candle has been making handmade Japanese candles for over a century. Each piece offers a calm, flickering light — a reflection of Noto’s serene nature and craftsmanship.</p>
                            <p>Even after the recent earthquake, the maker continues from a temporary store. At Akebono, we use their incense to warmly welcome guests at the entrance and living space.</p>
                        </div>
                    </div>
                </section>

                {/* Lightbox */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        {/* ▼▼▼ CORRECTED LIGHTBOX ▼▼▼ */}
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="Enlarged view" className="lightbox-content" />
                    </div>
                )}
            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default CraftEn;